import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/music/page.tsx");
